import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Topbar from "../../../Component/Topbar/Topbar";

const Pending = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const navigate = useNavigate();

  const stats = [
    { label: "Pending", value: 3, path: "/pending-table" },
    { label: "Inventory", value: 4, path: "/inventory-table" },
    { label: "Technical", value: 4, path: "/technical-table" },
    { label: "Next Visit", value: 3, path: "/next-visit" },
    { label: "Senior Service Engineer Support", value: 6, path: "/service-table" },
  ];

  const handleClick = (index, path) => {
    setActiveIndex(index);
    navigate(path);
  };

  return (
    <div>
      <Topbar header="Pending" subHead="Move" />
      <div className="container_fluit1 px-4 py-3">
        <div className="d-flex flex-wrap gap-3 ac-js">
          {stats.map((item, index) => (
            <div
              key={index}
              className={`box_Value d-flex ac-jc ${
                activeIndex === index ? "box_Value_active" : ""
              }`}
              onClick={() => handleClick(index, item.path)}
              style={{ cursor: "pointer" }}
            >
              <button
                className="m-0 btn w-100 text-wrap f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20"
                style={{
                  border: "none",
                  background: "transparent",
                  color: activeIndex === index ? "white" : "black",
                }}
              >
                {`${item.label} - ${item.value}`}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Pending;
